/**
 * Chrome French tip nails — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_nails_shades`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const chromeFrenchTipNailsPack: ToilePack = {
    slug: 'chrome-french-tip-nails',
    category: 'beauty',
    name: 'Chrome French tip nails',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'silver', label: 'Silver tips', subject: 'short square nails with a nude base and mirror silver chrome French tips'},
        {key: 'gold', label: 'Gold tips', subject: 'almond nails with thin gold chrome French tips'},
        {key: 'aura', label: 'Aura chrome', subject: 'oval nails with an iridescent chrome French tip over milky pink'},
    ],
    styles: [
        {key: 'mirror', label: 'Mirror shine', style: 'laid on a polished black surface, soft light from overhead drawing a bright reflection along each chrome tip, a crisp high-contrast balance', palette: 'Black gloss below, nude nails and bright metal above', framing: 'From directly above, the hand flat with its faint reflection beneath'},
        {key: 'garden', label: 'Garden', style: 'outdoors in soft afternoon daylight from camera-right, the chrome picking up sky and leaves, a bright natural balance', palette: 'Soft green and sky blue blur, warm skin', framing: 'A near-frontal close view, the hand raised against an out-of-focus garden'},
        {key: 'party', label: 'Party', style: 'at an evening party, warm soft glow from camera-left, a warm dim balance with the chrome tips the brightest points', palette: 'Warm gold out-of-focus dots and deep shadow', framing: 'A near-frontal close view, the fingers around a champagne flute'},
    ],
    directions: ['black chrome', 'coffin shape', 'toe nails'],
    directionHint: 'try: black chrome',
    seo: {
        title: 'Chrome French Tip Nails: Silver, Gold, Aura',
        metaDescription: 'Nine chrome French tip nail pictures: silver, gold and aura chrome tips on square, almond and oval nails.',
        h1: 'Chrome French tip nails: silver, gold, aura',
        tagline: 'Nine pictures of chrome French tips, three metal finishes shown in three settings.',
        intro: 'A chrome French tip puts a mirror metal finish along the tip of the nail. The nine pictures show silver tips on square nails, thin gold tips on almond nails and an iridescent aura tip over milky pink on oval nails. Each appears on a black gloss surface, in a garden and at an evening party. Type a different colour or shape, such as black chrome or coffin shape, and the same settings carry it.',
        useCases: [
            'a silver nail idea for a wedding or a party',
            'a shape and colour reference for a salon visit',
            'a holiday manicure with a metal finish',
            'a picture to show your nail technician',
        ],
        faq: [
            {q: 'Which metal colours are shown?', a: 'Silver, gold and an iridescent aura chrome over milky pink.'},
            {q: 'Which nail shapes are in the pictures?', a: 'Square nails for the silver tips, almond nails for the gold, and oval nails for the aura.'},
            {q: 'What are the three settings?', a: 'A polished black surface, an outdoor garden in afternoon daylight, and an evening party with warm light.'},
            {q: 'Can I ask for a different shape?', a: 'Yes, such as coffin shape. Type it as a request. The picture is not promised to match it exactly.'},
        ],
    },
}
